let timers = {};
export function setIdTimer(id, time, callback) {
    if (timers[id])
        clearTimeout(timers[id]);
    timers[id] = setTimeout(() => {
        if (!timers[id])
            return;
        removeTimer(id);
        callback();
    }, time);
}
export function removeTimer(id) {
    if (timers[id]) {
        clearTimeout(timers[id]);
        delete timers[id];
    }
}
